import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getIssueAcceptanceStockList = createAsyncThunk('/party/getIssueStockList',
    async (payload) => {
        try {
            const myurl = `${V_URL}/user/get-voucher-details`;

            const response = await axios({
                method: 'post',
                data:payload,
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {

            toast.error(error.response.data.message);
            return error
        }
    })

const getIssueAcceptanceStockSlice = createSlice({
    name: "getPmsIssueAcceptanceStockList",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getIssueAcceptanceStockList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getIssueAcceptanceStockList.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getIssueAcceptanceStockList.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getIssueAcceptanceStockSlice.reducer;